export const BRAND_NAME = "rynekpierwotny.pl";
export const YEARS_OF_EXPERIENCE = 16;
export const WORKERS_COUNT = 200;
export const BRAND_NAME = "rynekpierwotny.pl";
export const YEARS_OF_EXPERIENCE = 16;
export const WORKERS_COUNT = 200;
